import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Store
import { prepayHotelRatesFilterEnabled } from '@src/store/selectors';
// Constants
import { FARE_PAYMENT_TYPE } from '@src/util/const';
import { ENVIRONMENT } from '@src/shared/src/const/app';
// Utils
import { isEnvSearch } from '@src/util/app';
import useBreakpoints from '@toolkit/util/useBreakpoints';
// Components
import { Button } from '@toolkit/ui';
import { NonCompliantBadge } from '@src/components/NonCompliantBadge';

type Props = {
  fareId: string;
  farePaymentType: string;
  env: ENVIRONMENT;
  isBasketEditable?: boolean;
  onSelectHotel?: (hotelFareIds: string[]) => void;
  isSelectingHotel?: boolean;
  fareCompliant: boolean;
};

export const HotelFareSelectionButton: React.FC<Props> = ({
  fareId,
  farePaymentType,
  env,
  isBasketEditable,
  onSelectHotel,
  isSelectingHotel,
  fareCompliant,
}) => {
  const { t } = useTranslation();
  const { isMd } = useBreakpoints();
  const isPrepayHotelRatesFilterEnabled = useSelector(prepayHotelRatesFilterEnabled);

  const getTooltipMessage = () => {
    if (!fareCompliant && !isMd) {
      return t('tariffOptions.option.notCompliant');
    }

    return null;
  };

  if (isPrepayHotelRatesFilterEnabled && farePaymentType === FARE_PAYMENT_TYPE.PREPAY) {
    return (
      <div className="hotel-fare-group-item-button">
        <Button className="button" disabled>
          <i
            className="icon-info_outline is--first"
            data-rh={t('hotelFare.tooltip.prepayHotelRatesDisabled')}
          />
          &nbsp;{t('global.deactivated')}
        </Button>
      </div>
    );
  }

  if (isEnvSearch(env) && isBasketEditable) {
    return (
      <div className="hotel-fare-group-item-button">
        <Button
          data-rh={getTooltipMessage()}
          data-rh-at="top"
          className="button button-light"
          onClick={() => onSelectHotel?.([fareId])}
          isLoading={isSelectingHotel}>
          {t('global.select')}
        </Button>
        {!fareCompliant && !isMd && <NonCompliantBadge />}
      </div>
    );
  }
};
